import HeartActiveIcon from '@/fo/icons/base/icons/heart-active.svg';
import HeartIcon from '@/fo/icons/base/icons/heart.svg';

import { styles } from './UiProductWishlistButton.styles';

export interface UiProductWishlistButtonProps {
  onClick?: () => void;
  className?: string;
  isActive: boolean;
}

export function UiProductWishlistButton({
  onClick,
  className,
  isActive = false
}: UiProductWishlistButtonProps) {
  const slots = styles();

  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.();
      }}
      type="button"
      className={slots.base({ className })}
      data-mobile-app-hidden="commerce"
    >
      {isActive ? <HeartActiveIcon /> : <HeartIcon />}
    </button>
  );
}
